<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="用户">
                  <!-- <el-input  v-model="queryForm.userId"></el-input> -->
                  <GridSelectU title="选择用户" style="width: 177px;" labelName="userName" labelValue="id" :value="queryForm.userId" :limit='1'
                    size='small' placeholder='请选择用户' @getValue="getSeachValuebrandId" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="登录客户端">
                  <el-input style="width: 177px;" v-model="queryForm.loginClient"></el-input>
              </el-form-item>
              <el-form-item label="登录ip">
                  <el-input style="width: 177px;" v-model="queryForm.loginIp"></el-input>
              </el-form-item>
              <el-form-item label="登录ip归属地">
                  <el-input style="width: 177px;" v-model="queryForm.loginPlace"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppLogLoginList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addMppLogLogin"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editMppLogLogin(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppLogLogin(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshMppLogLoginList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppLogLoginList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
      > 
      <template slot-scope="scope">
          <div v-if="scope.row.user">
              <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
              <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
              <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
              <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
          </div>
          <div v-else>--</div>
      </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="loginClient"
        label="登录客户端"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="loginIp"
        label="登录ip"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="loginPlace"
        label="登录ip归属地"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="loginTime"
        label="登录时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="200"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkMppLogLogin(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <!-- <div @click="editMppLogLogin(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div> -->
            <div @click="deleteMppLogLogin(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppLogLoginStates[mppLogLoginState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppLogLogin"
          ref="mppLogLoginForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              v-model="mppLogLogin.userId"
              :disabled="mppLogLoginState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 177px;" labelName="userName" title="选择用户" :disabled="mppLogLoginState == 'check'"
                labelValue="id" :value="mppLogLogin.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="登录客户端"
            prop="loginClient"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppLogLogin.loginClient"
              :disabled="mppLogLoginState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="登录ip"
            prop="loginIp"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppLogLogin.loginIp"
              :disabled="mppLogLoginState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="登录ip归属地"
            prop="loginPlace"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppLogLogin.loginPlace"
              :disabled="mppLogLoginState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="登录时间"
            prop="loginTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="mppLogLogin.loginTime"
              :disabled="mppLogLoginState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppLogLoginState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect';
import { USER, USER_SEARCH } from '@/utils/constant'

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppLogLoginList();
                    this.getMppLogLoginList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppLogLoginList();
                    this.getMppLogLoginList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     id: '', //ID
                     userId: '', //用户
                     loginClient: '', //登录客户端
                     loginIp: '', //登录ip
                     loginPlace: '', //登录ip归属地
                     loginTime: '', //登录时间
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppLogLoginState: 'add',
                mppLogLoginStates: {
                    add: '新建日志',
                    check: '查看日志',
                    edit: '修改日志'
                },

                multipleSelection: [],
                mppLogLoginList: [],
                mppLogLogin: {
                    id: '', //ID
                    userId: '', //用户
                    loginClient: '', //登录客户端
                    loginIp: '', //登录ip
                    loginPlace: '', //登录ip归属地
                    loginTime: '', //登录时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    loginClient: [{ required: true, message: '登录客户端不能为空', trigger: 'blur' }],
                    loginIp: [{ required: true, message: '登录ip不能为空', trigger: 'blur' }],
                    loginPlace: [{ required: true, message: '登录ip归属地不能为空', trigger: 'blur' }],
                    loginTime: [{ required: true, message: '登录时间不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppLogLoginList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            getSeachValuebrandId(value) {
              this.queryForm.userId = value;
            },
            getValueUser(value) {
              this.mppLogLogin.userId = value
            },
            resetMppLogLoginList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppLogLoginList = [];
            },
            resetDialog() {
                this.mppLogLoginState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //ID
                      userId: '', //用户
                      loginClient: '', //登录客户端
                      loginIp: '', //登录ip
                      loginPlace: '', //登录ip归属地
                      loginTime: '', //登录时间
                };
                this.getMppLogLoginList();
            },
            closeDialog() {
                this.showDialog = false
                this.mppLogLogin = {
                      id: '', //ID
                      userId: '', //用户
                      loginClient: '', //登录客户端
                      loginIp: '', //登录ip
                      loginPlace: '', //登录ip归属地
                      loginTime: '', //登录时间
                };
            },
            submitForm() {
                if (this.mppLogLoginState == 'add') {
                    this.$refs.mppLogLoginForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/loglogin/add`,{ ...this.mppLogLogin }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppLogLoginList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.mppLogLoginState == 'edit') {
                    this.$refs.mppLogLoginForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/loglogin/edit`,{ ...this.mppLogLogin }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppLogLoginList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addMppLogLogin() {
                this.showDialog = true;
                this.mppLogLoginState = 'add';
            },
            checkMppLogLogin(mppLogLoginId) {
                console.log(mppLogLoginId);
                this.currentMppLogLoginId = mppLogLoginId;

                this.getMppLogLoginById();
                this.showDialog = true;
                this.mppLogLoginState = 'check';
            },
            editMppLogLogin(mppLogLoginId) {
                console.log('mppLogLogin', mppLogLoginId);
                if (mppLogLoginId) {
                    this.currentMppLogLoginId = mppLogLoginId;
                    this.getMppLogLoginById();
                } else {
                    this.mppLogLogin = { ...this.mppLogLogin, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppLogLoginState = 'edit';
            },
            deleteMppLogLogin(mppLogLoginId) {
                let ids = '';
                if (mppLogLoginId) {
                    ids = mppLogLoginId;
                } else {
                    ids = this.multipleSelection.map((mppLogLogin) => mppLogLogin.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/loglogin/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppLogLoginList();
                                this.getMppLogLoginList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppLogLoginList() {
                this.resetMppLogLoginList();
                this.getMppLogLoginList();
            },
            getMppLogLoginList(query = {}) {
                this.loading = true;
                get(`/mpp/loglogin/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppLogLoginList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getMppLogLoginById() {
                get(`/mpp/loglogin/get`,{ id: this.currentMppLogLoginId }).then((res) =>{
                    if(res.success){
                      this.mppLogLogin = { ...this.mppLogLogin, ...res.mppLogLogin };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppLogLoginList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/loglogin/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/loglogin/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/loglogin/importData`,formData);
              this.refreshMppLogLoginList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppLogLoginList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppLogLoginList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>